import { NgModule } from '@angular/core';
import { LoginInComponent } from './login-in.component';
import { RouterModule } from '@angular/router';
import { LoginOutletComponent } from './login-outlet/login-outlet.component';
import {CommonModule} from '@angular/common';
import { MaterialModule } from '../material';
import { NgxSpinnerModule } from 'ngx-spinner';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

export function translateHttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
@NgModule({
  imports: [
    
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: translateHttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    
    CommonModule,
    MaterialModule,
    NgxSpinnerModule,
    RouterModule.forChild(
      [{
        path: '', component: LoginOutletComponent,
        children: [
          // { path: 'login-in', component: },
          { path: 'login-in' , component: LoginInComponent},
          { path: '', redirectTo: 'login-in', pathMatch: 'full' }
        ]
      }]
    )
  ],
  declarations: [
    LoginOutletComponent,
    LoginInComponent
    
  ],
})
export class LoginModule { }
